module.exports = "<div class=\"not-found\">\n  <div class=\"text-center\">\n    <h1>Страница не найдена</h1>\n    <a>Перейти на логин</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/not-found/not-found.component.html
// module id = ./src/app/shared/components/not-found/not-found.component.html
// module chunks = main